import * as React from 'react';

import { DisplayAd } from 'constants/ads';

import { MesoDisplayAd } from './meso-display-ad';

export const MesoSideRail: React.FunctionComponent = () => (
  <>
    <MesoDisplayAd {...DisplayAd.SIDERAIL_R1} />
    <MesoDisplayAd {...DisplayAd.SIDERAIL_RM} />
    <MesoDisplayAd {...DisplayAd.SIDERAIL_R2} />
  </>
);
MesoSideRail.displayName = 'MesoSideRail';
